import { ListItem } from '../models/ListItem';
import { RoomType } from '../models/roomType.model';
import GenericService from './genericService';
import { httpService } from './httpService';

class RoomTypeService extends GenericService<RoomType, ListItem> {
  constructor() {
    super('/api/RoomType');
  }

  async getAllRoomTypes(): Promise<RoomType[]> {
    return await httpService.get<RoomType[]>('/api/RoomType/GetAll', undefined, {
      unwrap: true,
      normalize: true,
      toast: false,
    });
  }

  async getRoomTypesByProperty(propertyId: number): Promise<RoomType[]> {
    return await httpService.get<RoomType[]>(`/api/RoomType/GetByProperty/${propertyId}`, undefined, {
      unwrap: true,
      normalize: true,
      toast: false,
    });
  }
}

export const roomTypeService = new RoomTypeService();
